// extracted by mini-css-extract-plugin
export default {"done_recipes":"DoneRecipes_done_recipes__Ai8v6","cards":"DoneRecipes_cards__dZwHd"};